import React, { useEffect, useState } from "react";

import Form from "@Components/Form";
import { ROLES_URL, STORAGE_CONSTANT, URLS } from "configs/constants";
import { fetchDataFromApi, getAssignedModule } from "utils";
import { useParams, useHistory } from "react-router-dom";

import Modal from "components/Modal";
import CheckIcon from "@material-ui/icons/Check";
import BlockIcon from "@material-ui/icons/Block";
import eightAxios from "../../configs/axiosConfig";
import { useNotifyContext } from "components/Notify";
import { Grid, TextField } from "@material-ui/core";
import PropTypes from "prop-types";

const initialValues = {
  employee_id: "",
};

const urls = {
  proxyURL: "user/pending-profiles/",
  exportURL: "user/pending-profiles/export/",
  approveURL: "user/{id}/approve-profile/",
  declineURL: "user/{id}/decline-profile/",
};

const RemarkBody = ({ setRemarks, errorMessage }) => {
  const remarksHandler = (event) => {
    event.preventDefault();
    setRemarks(event.target.value);
  };
  return (
    <Grid container direction="column" spacing={2} style={{ padding: "10px" }}>
      <Grid item>
        <TextField
          variant="outlined"
          name="description"
          fullWidth
          multiline
          rows={3}
          inputProps={{ maxLength: 50 }}
          onChange={remarksHandler}
        />
        <Grid item justify="center">
          {errorMessage ? (
            <p style={{ textAlign: "center", color: "red" }}>{errorMessage}</p>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
};
RemarkBody.propTypes = {
  setRemarks: PropTypes.func,
  errorMessage: PropTypes.string,
};

const PendingProfileUpdateEdit = () => {
  const [remarks, setRemarks] = useState("");
  const [roles, setRoles] = useState([]);
  const [stateToRefresh, setStateToRefresh] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [modalFields, setModalFields] = useState({
    id: null,
    title: "Add Remarks",
    isOpen: false,
    body: null,
    confirmButtonLabel: "Reject User",
    onConfirm: null,
    type: "approve",
    resetModalBodyState: () => setErrorMessage(""),
  });

  const setNotify = useNotifyContext();
  const params = useParams();
  const history = useHistory();

  useEffect(() => {
    fetchDataFromApi(ROLES_URL, setRoles, true);
  }, []);

  useEffect(() => {
    const workerRole = roles.find((role) => role.name === "Worker");
    if (roles.includes(workerRole)) {
      setRoles(roles.filter((item) => item.name !== "Worker"));
    }
  }, [roles]);

  const formFields = [
    { type: "title", title: "Profile Update" },
    {
      type: "renderonly",
      name: "employee_id",
      key: "employee_id",
      label: "Employee ID",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "name",
      key: "name",
      label: "Employee Name",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "role",
      key: "role",
      label: "Role",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_number",
      key: "id_number",
      label: "ID Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "mobile_number",
      key: "mobile_number",
      label: "Mobile Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "company",
      key: "company",
      label: "Company",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "zone",
      key: "zone",
      label: "Zone",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "region",
      key: "region",
      label: "Region",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "estate",
      key: "estate",
      label: "Estate",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "division",
      key: "division",
      label: "Division",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "block",
      key: "block",
      label: "Block",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    
    { type: "title", title: "Audit Details" },
    {
      type: "renderonly",
      name: "created_at",
      key: "created_at",
      label: "Created Date and Time",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "created_by",
      key: "created_by",
      label: "Created By",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "approved_rejected_by",
      key: "approved_rejected_by",
      label: "Approved/Rejected By",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "status",
      key: "status",
      label: "Status",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "remarks",
      key: "remarks",
      label: "Remarks",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
  ];

  const approveWorker = () => {
    eightAxios
      .patch(urls.approveURL.replace("{id}", params.id))
      .then((response) => {
        setStateToRefresh(!stateToRefresh);
        setNotify({
          isOpen: true,
          message: response.data.message,
          type: "success",
        });
      })
      .catch(() => {
        setNotify({
          isOpen: true,
          message: "User approve failed. Please try again.",
          type: "error",
        });
      })
      .finally(() => history.push(URLS.PENDING_APPROVAL_PROFILE));
  };

  useEffect(() => {
    setModalFields({
      ...modalFields,
      body: <RemarkBody errorMessage={errorMessage} setRemarks={setRemarks} />,
      onConfirm: () => {
        eightAxios
          .patch(urls.declineURL.replace("{id}", modalFields.id), {
            remarks: remarks,
          })
          .then((response) => {
            setModalFields({ ...modalFields, isOpen: false });
            setNotify({
              isOpen: true,
              message: response.data.message,
              type: "success",
            });
          })
          .catch((error) => {
            if (error.response) {
              let errMsg = "";
              for (let key in error.response.data) {
                errMsg += error.response.data[key] + "\n";
              }
              setErrorMessage(errMsg);
              setNotify({
                isOpen: true,
                message: "User decline failed. Please try again.",
                type: "error",
              });
            } else {
              setErrorMessage(error.message);
              setNotify({
                isOpen: true,
                message: "User decline failed. Please try again.",
                type: "error",
              });
            }
          })
          .finally(() => history.push(URLS.PENDING_APPROVAL_PROFILE));
      },
    });
  }, [modalFields.id, errorMessage, remarks]);

  const declineWorker = () => {
    setModalFields({
      ...modalFields,
      id: params.id,
      isOpen: true,
    });
  };

  const formButtons = [
    {
      label: "Approve",
      startIcon: <CheckIcon />,
      color: "primary",
      onClick: () => approveWorker(),
    },
    {
      label: "Decline",
      startIcon: <BlockIcon />,
      onClick: () => declineWorker(),
    },
    "cancel",
  ];

  let module = getAssignedModule(location.pathname);
  let actionPermission = false;
  if (!module || module === "") {
    actionPermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("change status")) {
        actionPermission = true;
      }
    }
  }

  return (
    <div>
      <Form
        initialValues={initialValues}
        submitUrl="user-profile-change/"
        listRoute={URLS.PENDING_APPROVAL_PROFILE}
        formFields={formFields}
        formButtons={actionPermission ? formButtons : ["cancel"]}
        formTitle="Pending Profile Update"
        noTypography
      />
      <Modal modalFields={modalFields} setModalFields={setModalFields} />
    </div>
  );
};

export default PendingProfileUpdateEdit;
